import { EnhancedLabeledSelectProps } from '@gorila-shared-ui/components';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { gptAlarmTypesState } from '../../storage/gptStates';
import { EnhancedLabeledSelect } from '../ui/EnhancedLabeledSelect';

type Props = {
  onChange: (alarmTypeId?: string) => void;
  alarmTypeId?: string;
  emptyLabel?: string;
} & Omit<
  EnhancedLabeledSelectProps,
  'value' | 'options' | 'onChange' | 'searchable' | 'fetchDataLoading' | 'maxDropdownHeight'
>;

function AlarmTypeSelect({
  alarmTypeId: fileTypeId,
  onChange,
  emptyLabel = 'Todos',
  inline = true,
  inset = true,
  label = 'Alarma:',
  ...props
}: Readonly<Props>) {
  const alarmTypes = useRecoilValue(gptAlarmTypesState);

  const alarmTypeOptions = useMemo(() => {
    return [
      { id: undefined, label: emptyLabel },
      ...(alarmTypes
        ?.filter((alarmType) => !!alarmType.active)
        ?.map((alarmType) => ({ id: alarmType.code.toString(), label: alarmType.name })) ?? []),
    ];
  }, [alarmTypes, emptyLabel]);

  return (
    <EnhancedLabeledSelect
      {...props}
      inline={inline}
      inset={inset}
      label={label}
      options={alarmTypeOptions}
      value={[{ id: fileTypeId }]}
      onChange={(params) => {
        onChange(params.option?.id ? (params.option?.id as string) : undefined);
      }}
      disabled={!alarmTypes}
      searchable
    />
  );
}

export default AlarmTypeSelect;
